import {
  Button,
  Collapse,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SwipeableDrawer,
} from "@mui/material";
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import langIcon from "../../../assets/icons/lang.svg";
import { useTranslation } from "react-i18next";
import { resources } from "src/i18n";

type MenuItem = {
  label: string;
  href: string;
};

interface MobileSidebarProps {
  open: boolean;
  menu: MenuItem[];
  onOpen: () => void;
  onClose: () => void;
}

const MobileSidebar: FC<MobileSidebarProps> = (props) => {
  const { open, menu, onOpen, onClose } = props;
  const [langMenuOpen, setLangMenuOpen] = useState(true);
  const { t, i18n } = useTranslation(["langs"]);

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: 250,
        },
      }}
    >
      <List component="nav">
        <ListItemButton onClick={() => setLangMenuOpen(!langMenuOpen)}>
          <ListItemIcon>
            <img src={langIcon} alt="" height="20" />
          </ListItemIcon>
          <ListItemText primary={t(`langs:${i18n.language}`)} />
          {langMenuOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={langMenuOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {Object.keys(resources).map(
              (lang) =>
                lang !== i18n.language && (
                  <ListItemButton
                    key={lang}
                    sx={{ pl: 4 }}
                    onClick={() => {
                      i18n.changeLanguage(lang);
                    }}
                  >
                    <ListItemText primary={t(`langs:${lang}`)} />
                  </ListItemButton>
                )
            )}
          </List>
        </Collapse>
        <Divider />
        {menu.map(({ label, href }) => (
          <ListItemButton key={label} LinkComponent={Link} href={href}>
            <ListItemText>{label}</ListItemText>
          </ListItemButton>
        ))}
      </List>
    </SwipeableDrawer>
  );
};

export default MobileSidebar;
